import { EnderecoDTO } from "./enderecoDTO";

export class OperadorDTO {
  public gerente!: string;
  public nomeGerente!: string;
  public id!: string | null;
  public ativo!: boolean;
  public nome!: string;
  public cpf!: string;
  public email!: string;
  public cidade!: string;
  public numeroCertificacao!: string;
  public enderecoDTO!: EnderecoDTO | undefined;
  public telefoneComercial!: string;
  public telefoneCelular!: string;
  public codigoExterno!: string;
  public idsPontosDeVenda!: (string | number)[]; 
  public tipoVinculo!: string;
  public pontoVenda!: string | number; 
  public nomePontoVenda!: string;
  public situacaoConsultaCertificado!: string | null;
  public situacaoCertificado!: string | null;
  public certificado!: string | null;
  public certificados?: any[];
}